// extracted by mini-css-extract-plugin
module.exports = {"title":"sendMoney_title__23DVN","frame":"sendMoney_frame__7kRD_","boxTitle":"sendMoney_boxTitle__3_7Qp","devButton":"sendMoney_devButton__1I-EJ"};